import React, { useState } from "react";
import { EVoucherService } from "../../../../services/EVoucherService";
import { DateHelper } from "../../../../common/Helpers";
import { PageSizeSelector, Paginator } from "../../../../common/Paginator";
import { Constants } from "../../../common/Constant";

export const EVouchersInformationTable = (props) => {
  const { data, eVoucherExtensionRequestId } = props;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(Constants.PageSizes[0]);
  const [eVouchers, setEVouchers] = useState([]);

  const onPageSizeChange = (pageSize) => {
    setPageSize(pageSize);
    setPageIndex(1);
  };

  React.useEffect(() => {
    const loadEVouchers = async () => {
      if (data.length === 0) return;
      const startAt = (pageIndex - 1) * pageSize;
      const response = await new EVoucherService().list({
        eVoucherExtensionRequestId,
        startAt,
        maxResults: pageSize,
      });

      if (response.status === 200) {
        setEVouchers(response.data.data);
      }
    };

    void loadEVouchers();
  }, [data, pageIndex, pageSize, eVoucherExtensionRequestId]);

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="table-responsive m-b-10 table-px-15">
            <table className="table table-borderless table-striped table-earning">
              <thead>
                <tr>
                  <th className="text-center">Code</th>
                  <th className="text-center">E-Voucher Program</th>
                  <th className="text-center">Validity Start</th>
                  <th className="text-center">Expiry Date:</th>
                  <th className="text-center">Remaining Duration</th>
                </tr>
              </thead>
              <tbody>
                {eVouchers.map((item) => (
                  <tr key={item.id} style={{ cursor: "default" }}>
                    <td className="text-center">
                      <a href={`/evouchers/evouchers/${item.id}`}>
                        {item.code}
                      </a>
                    </td>
                    <td className="text-center">
                      {item.eVoucherProgram?.shortName}
                    </td>
                    <td className="text-center">
                      {DateHelper.toDisplayDateTimeFormat(item.validityStart)}
                    </td>
                    <td className="text-center">
                      {DateHelper.toDisplayDateTimeFormat(item.validityEnd)}
                    </td>
                    <td className="text-center">
                      {Math.ceil(item.remainingDuration)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between m-b-10">
            <Paginator
              onPageIndexChange={setPageIndex}
              pageIndex={pageIndex}
              pageSize={pageSize}
              total={data.length}
            />
            <div>
              <PageSizeSelector
                onPageSizeChange={onPageSizeChange}
                pageSize={pageSize}
                selectors={Constants.PageSizes}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
